import Image from 'next/image';

import GLogo from '../assets/google-logo.svg';

export const GoogleLogo: React.FC = () => (
  <Image src={GLogo} alt="Google Logo" priority />
);
